var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFylla4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4844,
    height: 143,
    viewBox: "0 0 4844 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M603.131 133.59V142.907H635.904V143H648.779L612.342 0H599.467L604.441 23.1988H579.569V32.5154H606.649L632.487 133.59H603.131Z",
    fill: "#F42272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M545.26 143L533.168 44.0278L581.428 143H597.229L533.168 19.1542V0H520.644V26.625L529.342 143H545.26Z",
    fill: "#F42272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M474.191 9.31664L510.628 143H523.503L487.066 0H441.417V9.31664H474.191Z",
    fill: "#F42272"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M422.64 9.31664L459.078 143H471.953L435.515 0H389.867V9.31664H422.64Z",
    fill: "#F42272"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M327.782 0H313.736L378.851 143H391.726L383.964 0H369.918L367.919 18.5403H337.028L327.782 0ZM367.919 27.8571L374.876 97.1148L341.593 27.8571H367.919Z",
    fill: "#F42272"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M290.133 133.59V142.907H322.906V143H335.781L299.344 6.47336e-06H286.469L291.443 23.1988H266.571V32.5154H293.651L319.489 133.59H290.133Z",
    fill: "#F42272"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M232.262 143L220.17 44.0278L268.429 143H284.231L220.17 19.1542V6.47336e-06H207.646V26.625L216.344 143H232.262Z",
    fill: "#F42272"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M161.192 9.31664L197.63 143H210.505L174.068 6.47336e-06H128.419V9.31664H161.192Z",
    fill: "#F42272"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.642 9.31664L146.08 143H158.955L122.517 6.47336e-06H76.8691V9.31664H109.642Z",
    fill: "#F42272"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7838 6.47336e-06H0.738281L65.8532 143H78.7283L70.9665 6.47336e-06H56.9207L54.9214 18.5403H24.0307L14.7838 6.47336e-06ZM54.9214 27.8571L61.878 97.1148L28.5955 27.8571H54.9214Z",
    fill: "#F42272"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M923.352 133.59V142.907H956.125V143H969L932.563 0H919.688L924.661 23.1988H899.79V32.5154H926.87L952.708 133.59H923.352Z",
    fill: "#F42272"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M865.481 143L853.389 44.0278L901.648 143H917.449L853.389 19.1542V0H840.865V26.625L849.563 143H865.481Z",
    fill: "#F42272"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M794.411 9.31664L830.849 143H843.724L807.286 0H761.638V9.31664H794.411Z",
    fill: "#F42272"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M742.861 9.31664L779.298 143H792.174L755.736 0H710.088V9.31664H742.861Z",
    fill: "#F42272"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M648.002 0H633.957L699.072 143H711.947L704.185 0H690.139L688.14 18.5403H657.249L648.002 0ZM688.14 27.8571L695.096 97.1148L661.814 27.8571H688.14Z",
    fill: "#F42272"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1572.13 133.59V142.907H1604.9V143H1617.78L1581.34 0H1568.47L1573.44 23.1988H1548.57V32.5154H1575.65L1601.49 133.59H1572.13Z",
    fill: "#F42272"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1514.26 143L1502.17 44.0278L1550.43 143H1566.23L1502.17 19.1542V0H1489.64V26.625L1498.34 143H1514.26Z",
    fill: "#F42272"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1443.19 9.31664L1479.63 143H1492.5L1456.07 0H1410.42V9.31664H1443.19Z",
    fill: "#F42272"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1391.64 9.31664L1428.08 143H1440.95L1404.52 0H1358.87V9.31664H1391.64Z",
    fill: "#F42272"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1296.78 0H1282.74L1347.85 143H1360.73L1352.96 0H1338.92L1336.92 18.5403H1306.03L1296.78 0ZM1336.92 27.8571L1343.88 97.1148L1310.59 27.8571H1336.92Z",
    fill: "#F42272"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1259.13 133.59V142.907H1291.91V143H1304.78L1268.34 6.47336e-06H1255.47L1260.44 23.1988H1235.57V32.5154H1262.65L1288.49 133.59H1259.13Z",
    fill: "#F42272"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.26 143L1189.17 44.0278L1237.43 143H1253.23L1189.17 19.1542V6.47336e-06H1176.65V26.625L1185.34 143H1201.26Z",
    fill: "#F42272"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.19 9.31664L1166.63 143H1179.51L1143.07 6.47336e-06H1097.42V9.31664H1130.19Z",
    fill: "#F42272"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.64 9.31664L1115.08 143H1127.96L1091.52 6.47336e-06H1045.87V9.31664H1078.64Z",
    fill: "#F42272"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M983.784 6.47336e-06H969.738L1034.85 143H1047.73L1039.97 6.47336e-06H1025.92L1023.92 18.5403H993.031L983.784 6.47336e-06ZM1023.92 27.8571L1030.88 97.1148L997.596 27.8571H1023.92Z",
    fill: "#F42272"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1892.35 133.59V142.907H1925.13V143H1938L1901.56 0H1888.69L1893.66 23.1988H1868.79V32.5154H1895.87L1921.71 133.59H1892.35Z",
    fill: "#F42272"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1834.48 143L1822.39 44.0278L1870.65 143H1886.45L1822.39 19.1542V0H1809.87V26.625L1818.56 143H1834.48Z",
    fill: "#F42272"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1763.41 9.31664L1799.85 143H1812.72L1776.29 0H1730.64V9.31664H1763.41Z",
    fill: "#F42272"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1711.86 9.31664L1748.3 143H1761.17L1724.74 0H1679.09V9.31664H1711.86Z",
    fill: "#F42272"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1617 0H1602.96L1668.07 143H1680.95L1673.19 0H1659.14L1657.14 18.5403H1626.25L1617 0ZM1657.14 27.8571L1664.1 97.1148L1630.81 27.8571H1657.14Z",
    fill: "#F42272"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2542.13 133.59V142.907H2574.9V143H2587.78L2551.34 0H2538.47L2543.44 23.1988H2518.57V32.5154H2545.65L2571.49 133.59H2542.13Z",
    fill: "#F42272"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2484.26 143L2472.17 44.0278L2520.43 143H2536.23L2472.17 19.1542V0H2459.64V26.625L2468.34 143H2484.26Z",
    fill: "#F42272"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2413.19 9.31664L2449.63 143H2462.5L2426.07 0H2380.42V9.31664H2413.19Z",
    fill: "#F42272"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2361.64 9.31664L2398.08 143H2410.95L2374.52 0H2328.87V9.31664H2361.64Z",
    fill: "#F42272"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2266.78 0H2252.74L2317.85 143H2330.73L2322.96 0H2308.92L2306.92 18.5403H2276.03L2266.78 0ZM2306.92 27.8571L2313.88 97.1148L2280.59 27.8571H2306.92Z",
    fill: "#F42272"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M2229.13 133.59V142.907H2261.91V143H2274.78L2238.34 6.47336e-06H2225.47L2230.44 23.1988H2205.57V32.5154H2232.65L2258.49 133.59H2229.13Z",
    fill: "#F42272"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.26 143L2159.17 44.0278L2207.43 143H2223.23L2159.17 19.1542V6.47336e-06H2146.65V26.625L2155.34 143H2171.26Z",
    fill: "#F42272"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2100.19 9.31664L2136.63 143H2149.51L2113.07 6.47336e-06H2067.42V9.31664H2100.19Z",
    fill: "#F42272"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2048.64 9.31664L2085.08 143H2097.96L2061.52 6.47336e-06H2015.87V9.31664H2048.64Z",
    fill: "#F42272"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1953.78 6.47336e-06H1939.74L2004.85 143H2017.73L2009.97 6.47336e-06H1995.92L1993.92 18.5403H1963.03L1953.78 6.47336e-06ZM1993.92 27.8571L2000.88 97.1148L1967.6 27.8571H1993.92Z",
    fill: "#F42272"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2862.35 133.59V142.907H2895.13V143H2908L2871.56 0H2858.69L2863.66 23.1988H2838.79V32.5154H2865.87L2891.71 133.59H2862.35Z",
    fill: "#F42272"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M2804.48 143L2792.39 44.0278L2840.65 143H2856.45L2792.39 19.1542V0H2779.87V26.625L2788.56 143H2804.48Z",
    fill: "#F42272"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M2733.41 9.31664L2769.85 143H2782.72L2746.29 0H2700.64V9.31664H2733.41Z",
    fill: "#F42272"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M2681.86 9.31664L2718.3 143H2731.17L2694.74 0H2649.09V9.31664H2681.86Z",
    fill: "#F42272"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M2587 0H2572.96L2638.07 143H2650.95L2643.19 0H2629.14L2627.14 18.5403H2596.25L2587 0ZM2627.14 27.8571L2634.1 97.1148L2600.81 27.8571H2627.14Z",
    fill: "#F42272"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M3510.13 133.59V142.907H3542.9V143H3555.78L3519.34 0H3506.47L3511.44 23.1988H3486.57V32.5154H3513.65L3539.49 133.59H3510.13Z",
    fill: "#F42272"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M3452.26 143L3440.17 44.0278L3488.43 143H3504.23L3440.17 19.1542V0H3427.64V26.625L3436.34 143H3452.26Z",
    fill: "#F42272"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M3381.19 9.31664L3417.63 143H3430.5L3394.07 0H3348.42V9.31664H3381.19Z",
    fill: "#F42272"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M3329.64 9.31664L3366.08 143H3378.95L3342.52 0H3296.87V9.31664H3329.64Z",
    fill: "#F42272"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M3234.78 0H3220.74L3285.85 143H3298.73L3290.96 0H3276.92L3274.92 18.5403H3244.03L3234.78 0ZM3274.92 27.8571L3281.88 97.1148L3248.59 27.8571H3274.92Z",
    fill: "#F42272"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M3197.13 133.59V142.907H3229.91V143H3242.78L3206.34 6.47336e-06H3193.47L3198.44 23.1988H3173.57V32.5154H3200.65L3226.49 133.59H3197.13Z",
    fill: "#F42272"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M3139.26 143L3127.17 44.0278L3175.43 143H3191.23L3127.17 19.1542V6.47336e-06H3114.65V26.625L3123.34 143H3139.26Z",
    fill: "#F42272"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M3068.19 9.31664L3104.63 143H3117.51L3081.07 6.47336e-06H3035.42V9.31664H3068.19Z",
    fill: "#F42272"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M3016.64 9.31664L3053.08 143H3065.96L3029.52 6.47336e-06H2983.87V9.31664H3016.64Z",
    fill: "#F42272"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M2921.78 6.47336e-06H2907.74L2972.85 143H2985.73L2977.97 6.47336e-06H2963.92L2961.92 18.5403H2931.03L2921.78 6.47336e-06ZM2961.92 27.8571L2968.88 97.1148L2935.6 27.8571H2961.92Z",
    fill: "#F42272"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M3830.35 133.59V142.907H3863.13V143H3876L3839.56 0H3826.69L3831.66 23.1988H3806.79V32.5154H3833.87L3859.71 133.59H3830.35Z",
    fill: "#F42272"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M3772.48 143L3760.39 44.0278L3808.65 143H3824.45L3760.39 19.1542V0H3747.87V26.625L3756.56 143H3772.48Z",
    fill: "#F42272"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M3701.41 9.31664L3737.85 143H3750.72L3714.29 0H3668.64V9.31664H3701.41Z",
    fill: "#F42272"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M3649.86 9.31664L3686.3 143H3699.17L3662.74 0H3617.09V9.31664H3649.86Z",
    fill: "#F42272"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M3555 0H3540.96L3606.07 143H3618.95L3611.19 0H3597.14L3595.14 18.5403H3564.25L3555 0ZM3595.14 27.8571L3602.1 97.1148L3568.81 27.8571H3595.14Z",
    fill: "#F42272"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M4478.13 133.59V142.907H4510.9V143H4523.78L4487.34 0H4474.47L4479.44 23.1988H4454.57V32.5154H4481.65L4507.49 133.59H4478.13Z",
    fill: "#F42272"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M4420.26 143L4408.17 44.0278L4456.43 143H4472.23L4408.17 19.1542V0H4395.64V26.625L4404.34 143H4420.26Z",
    fill: "#F42272"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M4349.19 9.31664L4385.63 143H4398.5L4362.07 0H4316.42V9.31664H4349.19Z",
    fill: "#F42272"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M4297.64 9.31664L4334.08 143H4346.95L4310.52 0H4264.87V9.31664H4297.64Z",
    fill: "#F42272"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M4202.78 0H4188.74L4253.85 143H4266.73L4258.96 0H4244.92L4242.92 18.5403H4212.03L4202.78 0ZM4242.92 27.8571L4249.88 97.1148L4216.59 27.8571H4242.92Z",
    fill: "#F42272"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M4165.13 133.59V142.907H4197.91V143H4210.78L4174.34 6.47336e-06H4161.47L4166.44 23.1988H4141.57V32.5154H4168.65L4194.49 133.59H4165.13Z",
    fill: "#F42272"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M4107.26 143L4095.17 44.0278L4143.43 143H4159.23L4095.17 19.1542V6.47336e-06H4082.65V26.625L4091.34 143H4107.26Z",
    fill: "#F42272"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M4036.19 9.31664L4072.63 143H4085.51L4049.07 6.47336e-06H4003.42V9.31664H4036.19Z",
    fill: "#F42272"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M3984.64 9.31664L4021.08 143H4033.96L3997.52 6.47336e-06H3951.87V9.31664H3984.64Z",
    fill: "#F42272"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M3889.78 6.47336e-06H3875.74L3940.85 143H3953.73L3945.97 6.47336e-06H3931.92L3929.92 18.5403H3899.03L3889.78 6.47336e-06ZM3929.92 27.8571L3936.88 97.1148L3903.6 27.8571H3929.92Z",
    fill: "#F42272"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M4798.35 133.59V142.907H4831.13V143H4844L4807.56 0H4794.69L4799.66 23.1988H4774.79V32.5154H4801.87L4827.71 133.59H4798.35Z",
    fill: "#F42272"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M4740.48 143L4728.39 44.0278L4776.65 143H4792.45L4728.39 19.1542V0H4715.87V26.625L4724.56 143H4740.48Z",
    fill: "#F42272"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M4669.41 9.31664L4705.85 143H4718.72L4682.29 0H4636.64V9.31664H4669.41Z",
    fill: "#F42272"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M4617.86 9.31664L4654.3 143H4667.17L4630.74 0H4585.09V9.31664H4617.86Z",
    fill: "#F42272"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M4523 0H4508.96L4574.07 143H4586.95L4579.19 0H4565.14L4563.14 18.5403H4532.25L4523 0ZM4563.14 27.8571L4570.1 97.1148L4536.81 27.8571H4563.14Z",
    fill: "#F42272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFylla4);
export default __webpack_public_path__ + "static/media/fylla4.1c40ccf1f7501c4862d34f052e234a3b.svg";
export { ForwardRef as ReactComponent };